import React from 'react'
import {Col} from 'reactstrap'
import Error from './elements/Error'
import LabelWithInfo from './elements/LabelWithInfo'
import CheckBox from '../elements/CheckBox'

function MultiCheckVal(props) {

    const {name, info, data, field, stuff, disabled, error} = props;
    let value = data && field && data[field];

    // invalid default value
    if (!value || !Array.isArray(value) || !value.every(e => typeof(e) === 'boolean')) {
        console.warn(`Unknown multicheck value ${value} for ${field}`);
        value = Array(stuff?.length).fill(false);
    }

    const onChange = (i) => {
        return (e) => {
            value[i] = !value[i];
            props.onChange(data, field, value);
        };
    };

    const checkButtons = stuff && stuff.map((e, i) => {
        return (<CheckBox key={i} checked={value[i]} label={e.name} disabled={disabled} onChange={onChange(i)} />);
    });

    return (
        <div className="form-group row g-0">
            <Col sm="12">
                <div className="my-2">
                    <LabelWithInfo name={name} info={info} />
                </div>

                {checkButtons}

                {error &&
                <Error id={field} error={error}/>}
            </Col>
        </div>);
}

export default MultiCheckVal;